<template>
<div class="form">
  <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <h1 align="center" style="text-decoration: underline overline;">JRB - Penerimaan  <label class="font-italic">One-Off </label></h1>
      <!-- <h2 align="center" style="text-decoration:">Penerimaan One-Off (COVID19)</h2>  -->

        <v-text-field
          outlined 
          dense
          rounded
          v-model="HID"
          label="HID"
          :rules="rules"
          width="20px"
          disabled
        ></v-text-field>

      <!-- DATATABLE  -->
      <v-card color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="formatdataJRB1off"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
              :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
            ></v-data-table>
      </v-card>    
    </v-card>  


<!-- ISI BORANG -->
<v-card>
<v-card-text>
  <v-form ref="form" v-model="valid" lazy-validation>


 <v-row>
  <v-col> 
      <span><strong>Berapa banyakkah pendapatan yang diterima dalam dua belas (12) bulan yang lalu yang berupa :</strong></span>
  </v-col> 
</v-row>

 <v-row>
      <v-col class="black--text">  
      S120 : Nilai penerimaan pusaka <strong>[INCS10a]</strong>
        <v-text-field
          v-model="INCS10_a"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
         >
        </v-text-field>
        </v-col>


        <v-col class="black--text">  
      S121 : Nilai penerimaan hadiah/loteri <strong>[INCS10b]</strong>
        <v-text-field
          v-model="INCS10_b"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
         >
        </v-text-field>
        </v-col>
 </v-row>

 <v-row>
      <v-col class="black--text">  
      S122 : Nilai penerimaan pampasan   <strong>[INCS10c]</strong>
        <v-text-field
          v-model="INCS10_c"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
         >
        </v-text-field>
        </v-col>


        <v-col class="black--text">  
      S123 : Nilai penerimaan ganjaran <strong>[INCS10d]</strong>
        <v-text-field
          v-model="INCS10_d"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
         >
        </v-text-field>
        </v-col>
 </v-row>

 <v-row>
      <v-col class="black--text">  
      S124 : Nilai penerimaan derma/sumbangan dari individu/NGO   <strong>[INCS10e]</strong>
        <v-text-field
          v-model="INCS10_e"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
         >
        </v-text-field>
        </v-col>


        <v-col class="black--text">  
      S125 : Nilai penerimaan pinjaman <strong>[INCS10f]</strong>
        <v-text-field
          v-model="INCS10_f"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
         >
        </v-text-field>
        </v-col>
 </v-row>

 <v-row>
      <v-col class="black--text">  
      S126 : Nilai penerimaan jualan aset <strong>[INCS10g]</strong>
        <v-text-field
          v-model="INCS10_g"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
         >
        </v-text-field>
        </v-col>


        <v-col class="black--text">  
      S127 : Nilai penerimaan lain-lain <strong>[INCS10h]</strong>
        <v-text-field
          v-model="INCS10_h"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
         >
        </v-text-field>
        </v-col>
 </v-row>
 
 


<!-- <v-row>
   <v-col class="black--text">
    i) Kerajaan Persekutuan <strong>[INCS10d(i)]</strong>
    <v-text-field
        v-model="INCS10_di"
          label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
          >
        </v-text-field>
  </v-col>  
   
   <v-col class="black--text">   
    ii) Kerajaan Negeri <strong>[INCS10d(ii)]</strong>
        <v-text-field
         v-model="INCS10_dii"
          type="number"
          label="RM"
          outlined 
          dense
          persistent-hint
          hint="Setahun"
          >
        </v-text-field>
  </v-col>  

   <v-col class="black--text">
         Jumlah hadiah berupa wang tunai dari Kerajaan <strong>[INCS10d]</strong>
        <v-text-field
          v-model="INCS10_d"
          label="RM"
          outlined
          type="number"
          dense
          disabled
          hint="Setahun"
          persistent-hint
          >
        </v-text-field>
  </v-col>                
</v-row> -->

<!-- <v-row>   
     <v-col class="black--text">
      S124 : Penerimaan bantuan lain dalam bentuk mata benda   
     </v-col>           
</v-row> -->

<!-- <v-row>  
        <v-col class="black--text">   
         i) Kerajaan Persekutuan <strong>[INCS10e(i)]</strong>
        <v-text-field
        v-model="INCS10_ei"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          >
        </v-text-field>
  </v-col>  

 <v-col class="black--text">  
         ii)  Kerajaan Negeri <strong>[INCS10e(ii)]</strong>
        <v-text-field
          v-model="INCS10_eii"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          >
        </v-text-field>
  </v-col>  
  
    <v-col class="black--text"> 
         Jumlah hadiah bantuan lain (mata benda) dari kerajaan. <strong>[INCS10e]</strong>
        <v-text-field
          v-model="INCS10_e"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          disabled
          >
        </v-text-field>
    
  </v-col>               
</v-row>       -->

<!-- <v-row>
<v-col cols ="4" class="black--text">
  S125 : Lain-lain <strong>[INCS10f]</strong>
        <v-text-field
        v-model="INCS10_f"
        type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          >
        </v-text-field>              
</v-col>

<v-col cols ="4" class="black--text">
         S126 :  Jumlah penerimaan bantuan one-off <strong>[INCS10]</strong>
         <v-text-field
          v-model="INCS10"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          disabled>
          </v-text-field> 
</v-col>
</v-row> -->
</v-form>
</v-card-text>


<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateJRB1off()"
    >
      Kemaskini
    </v-btn>

    <!-- <v-btn
      text
      color="primary"
      @click="goTo()"
    >
      Seterusnya
    </v-btn> -->
</v-card-actions>
</v-card>

<!-- <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert> -->

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>
    

</div>
</template>
<script>
import axios from '../../plugins/axios'

/////////////////////////////////////////////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
/////////////////////////////////////////////////////////
export default {
   
    async beforeMount(){

        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

///////////////////////////////lookup table yang diperlukan//////////////////

        
        this.yaTidak = lookupFieldServices.getYaTidak();
        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        this.getData();//dapatkan data based on HID

    },
    setup() {
        
    },
    data: () => ({
        updateButton: true,
        saveButton: false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        search: '',
        currNOAIRData:'',
        yaTidak:[],
        butangSimpan: true,
        butangKemaskini: false,


        /////////////////////data declaration//////////////////////////
        HID: '',
        KAW: '',
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:'',
        NOAIR:'',

        // JRBS118 :[],
        INCS10_a :0,
        INCS10_b :0,
        INCS10_c :0,
        INCS10_d :0,
        INCS10_e :0,
        INCS10_f :0,
        INCS10_g :0,
        INCS10_h :0,

        //JRBS121 : [],
        //INCS10_di:0,
        //INCS10_dii:0,
        //INCS10_ei :0,
        //INCS10_eii :0,
        //INCS10_f :0,
        dataJRB1off:[],
        rules: [
        value => !!value || 'Required.',
      ],

       headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          // { text: 'JRBS118', value: 'JRBS118' },
          { text: 'HID', value: 'HID' },
          { text: 'INCS10a', value: 'INCS10_a' },
          { text: 'INCS10b', value: 'INCS10_b' },
          //{ text: 'S121', value: 'JRBS121' },
          { text: 'INCS10c', value: 'INCS10_c' },
          // { text: 'INCS10d(i)', value: 'INCS10_di' },
          // { text: 'INCS10d(ii)', value: 'INCS10_dii' },
          { text: 'INCS10d', value: 'INCS10_d' },
          // { text: 'INCS10e(i)', value: 'INCS10_ei' },
          // { text: 'INCS10e(ii)', value: 'INCS10_eii' },
          { text: 'INCS10e', value: 'INCS10_e' },
          { text: 'INCS10f', value: 'INCS10_f' },
          { text: 'INCS10g', value: 'INCS10_g' },
          { text: 'INCS10h', value: 'INCS10_h' },
          { text: 'INCS10', value: 'INCS10' },
        ],
       
      ///////////link untuk ke page/////////////////////

      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
      //   {
      //     text: 'JRB Pindahan Semasa Diterima',
      //     disabled: false,
      //     href: 'JRBpindahan',
      //   },
      //  {
      //     text: 'JRB Penerimaan Bulan Sebelumnya',
      //     disabled: true,
      //     href: 'IMBANGAN',
      //   },
        {
          text: 'JRB Penerimaan one-off',
          disabled: true,
          href: 'JRB1off',
        },
        //  {
        //   text: 'JRC Pindahan Semasa Dibayar',
        //   disabled: false,
        //   href: 'JRCPSD',
        // },
        // {
        //   text: 'JRD Pinjaman Kewangan',
        //   disabled: false,
        //   href: 'JRD',
        // },
     
      ],
     
      select: null,
      checkbox: false,
    }),

//METHODS

    methods: {
      formatNumber(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
        stripCommas(value) {
      return value.replace(/,/g, '');
      },
      getUnits: function(a) {
            alert(`${a}`)
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

         goTo(){
          this.$router.push({name: "JRCPSD"});
      },

      async simpan (){
        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
            try {
            const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/insertJRB1off`, {
              
              // JRBS118 : this.JRBS118.id,
              INCS10_a : this.INCS10_a,
              INCS10_b : this.INCS10_b,
              INCS10_c : this.INCS10_c,
              INCS10_d : this.INCS10_d,
              INCS10_e : this.INCS10_e,
              INCS10_f : this.INCS10_f,
              INCS10_g : this.INCS10_g,
              INCS10_h : this.INCS10_h,
              INCS10 : this.INCS10,
              HID:  this.HID,
              NOAIR: this.NOAIR
    
              })
                this.res = res.data
                //console.log(this.res)
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Disimpan!';
                this.getData();
                 setTimeout(() => (this.goTo()), 2000);
                
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }
      },

        async padam(val){
        if(val == 0){
          this.popUpALert = true; 
        }
        else if(val == 1){
          
          try {
              ///////////tunjukkan alert padam////////////
              this.popUpALert = false;
                ////send delete to API///////
              if (this.$refs.form.validate()){
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/JRB1off/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Deleted!'
                this.saveButton = false;
                this.updateButton = true;
                this.reset();
                this.getData(); 
              }else{
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = "Please Fill In the field"
              }
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }
        }
        else if(val == 2){
          this.popUpALert = false;
        }
          
      },
     async getData(){

        //dapatkan data dari table JR5 based on HID

        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getJRB1off?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            var dataz = res.data.data
            this.dataJRB1off = dataz;
            console.log(this.dataJRB1off)
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }

      },

          async updateJRB1off(){
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/updateJRB1off`, {
                
              INCS10_a : this.INCS10_a,
              INCS10_b : this.INCS10_b,
              INCS10_c : this.INCS10_c,
              INCS10_d : this.INCS10_d,
              INCS10_e : this.INCS10_e,
              INCS10_f : this.INCS10_f,
              INCS10_g : this.INCS10_g,
              INCS10_h : this.INCS10_h,
              INCS10 : this.INCS10,
              HID:  this.HID,
              NOAIR: this.NOAIR,

              })
                this.res = res.data;
                this.butangKemaskini = false;
                this.successDialog = true;
                this.getData()
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Berjaya Dikemaskini!';
                this.reset();
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }

        
      },

        handleClick(row) {
          console.log('Row clicked:', row);
          // this.saveButton = true;
          // this.updateButton = true;
          this.butangSimpan = false;
          this.butangKemaskini = true;
          this.HID = row.HID;
          this.NOAIR = row.NOAIR,
          // this.JRBS118 = row.JRBS118;
          this.INCS10_a= this.stripCommas(row.INCS10_a);
          this.INCS10_b= this.stripCommas(row.INCS10_b);
          this.INCS10_c= this.stripCommas(row.INCS10_c);
          this.INCS10_d= this.stripCommas(row.INCS10_d);
          this.INCS10_e= this.stripCommas(row.INCS10_e);
          this.INCS10_f= this.stripCommas(row.INCS10_f);
          this.INCS10_g= this.stripCommas(row.INCS10_g);
          this.INCS10_h= this.stripCommas(row.INCS10_h);
          this.INCS10 = this.stripCommas(row.INCS10);

          //this.JRBS121 = this.yaTidak[row.JRBS121];
          // this.INCS10_di = row.INCS10_di;
          // this.INCS10_dii = row.INCS10_dii;
          // this.INCS10_ei = row.INCS10_ei;
          // this.INCS10_eii = row.INCS10_eii;

      },

      

        onChangeJRBS121(){

        if(this.JRBS121.id == 1){
         this.INCS10_c = 50
        }else{
           this.INCS10_c = 0
        }

      },



    },

//COMPUTED

    computed:{
       
        INCS10:function(){

          var total = 0;
          
          total =  Number(this.INCS10_a) + Number(this.INCS10_b) + Number(this.INCS10_c) + Number(this.INCS10_d) + Number(this.INCS10_e) +
                   Number(this.INCS10_f) + Number(this.INCS10_g) + Number(this.INCS10_h)
          return  total;
        },

        formatdataJRB1off() {
        return this.dataJRB1off.map(item => ({
          ...item,
          INCS10_a: this.formatNumber(item.INCS10_a),
          INCS10_b: this.formatNumber(item.INCS10_b),
          INCS10_c: this.formatNumber(item.INCS10_c),
          INCS10_d: this.formatNumber(item.INCS10_d),
          INCS10_e: this.formatNumber(item.INCS10_e),
          INCS10_f: this.formatNumber(item.INCS10_f),
          INCS10_g: this.formatNumber(item.INCS10_g),
          INCS10_h: this.formatNumber(item.INCS10_h),
          INCS10: this.formatNumber(item.INCS10),
        }));
      },

             
      //calculation lain letak bawah ni

      //   INCS10_d:function(){
      //   var total = 0;
      //   total = Number(this.INCS10_di) + Number(this.INCS10_dii)
      //   return  total;
      // },
      
      //   INCS10_e:function(){
      //   var total = 0;
      //   total = Number(this.INCS10_ei) + Number(this.INCS10_eii)
      //   return  total;
      // },
     
    }



 
}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>